<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="button-row">
      <button mat-raised-button class="m-1 mr-2" routerLink="../..">
        <mat-icon>arrow_back</mat-icon> Inspection/Audit Templates
      </button>
    </div>
  </nav>

  <h6 class="mx-4">Inspection/Audit Template</h6>
  <p class="mx-4">{{ audit.name }}</p>

  <mat-card appearance="outlined" class="mx-4 mb-4 scroll-box">
    <mat-card-content>
      <h6>Inspection/Audit Questions</h6>

      <table class="w-100" mat-table [dataSource]="audit.items">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Question</th>
          <td mat-cell *matCellDef="let item">{{ item.name }}</td>
        </ng-container>

        <ng-container matColumnDef="section">
          <th mat-header-cell *matHeaderCellDef>Section</th>
          <td mat-cell *matCellDef="let item">{{ item.section }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>

</div>
